module.exports = __webpack_public_path__ + "img/3abc_Attendance.84f25266.png";